import React from 'react';
import PhotoIcon from '@material-ui/icons/Photo';

export const EmptyArtwork = () => (
    <>
        <PhotoIcon />
        <p>No artwork available</p>
    </>
);

export default EmptyArtwork;
